import client from "../axios"
import { DELETE_CUSTOMERCENTER_FAQ, DELETE_CUSTOMERCENTER_INQUIRY, GET_CUSTOMERCENTER_FAQ, GET_CUSTOMERCENTER_FAQ_DETAIL, GET_CUSTOMERCENTER_INQUIRY_DETAIL, POST_CUSTOMERCENTER_FAQ, POST_CUSTOMERCENTER_INQUIRY, PUT_CUSTOMERCENTER_FAQ, PUT_CUSTOMERCENTER_FAQ_SORT, PUT_CUSTOMERCENTER_INQUIRY } from "./endpoint"

// 고객센터문의 등록
export const postCustomerCenterInquiryAPI = (data) => {
  return client.post(POST_CUSTOMERCENTER_INQUIRY, data)
}

// 고객센터문의 상세
export const getCustomerCenterInquiryDetailAPI = (idx, params) => {
  return client.get(GET_CUSTOMERCENTER_INQUIRY_DETAIL.replace(':idx', idx), { params })
}

// 고객센터문의 수정
export const putCustomerCenterInquiryAPI = (data) => {
  return client.put(PUT_CUSTOMERCENTER_INQUIRY, data)
}

// 고객센터문의 삭제
export const deleteCustomerCenterInquiryAPI = (data) => {
  return client.delete(DELETE_CUSTOMERCENTER_INQUIRY, {data})
}

// 고객센터FAQ 목록
export const getCustomerCenterFaqAPI = (params) => {
  return client.get(GET_CUSTOMERCENTER_FAQ, {params})
}

// 고객센터FAQ 등록
export const postCustomerCenterFaqAPI = (data) => {
  return client.post(POST_CUSTOMERCENTER_FAQ, data)
}

// 고객센터FAQ 상세
export const getCustomerCenterFaqDetailAPI = (idx, params) => {
  console.log(params)
  return client.get(GET_CUSTOMERCENTER_FAQ_DETAIL.replace(':idx', idx), { params })
}

// 고객센터FAQ 수정
export const putCustomerCenterFaqAPI = (data) => {
  return client.put(PUT_CUSTOMERCENTER_FAQ, data)
}

// 고객센터FAQ 삭제
export const deleteCustomerCenterFaqAPI = (data) => {
  return client.delete(DELETE_CUSTOMERCENTER_FAQ, {data})
}

// 고객센터FAQ 정렬순서
export const putCustomerCenterFaqSortAPI = (data) => {
  return client.put(PUT_CUSTOMERCENTER_FAQ_SORT, data)
}